import IMask from 'imask';

export const config = {
    mask: 'hh:mm',
    blocks: {
        hh: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
        },
        mm: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
        },
    },
};
